/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CorrectionResolution = {
    Code: 'code',
    QuotedReply: 'quoted_reply',
    MostRecent: 'most_recent',
    Unresolved: 'unresolved',
    Direct: 'direct',
    Thread: 'thread',
} as const;
export type CorrectionResolution = typeof CorrectionResolution[keyof typeof CorrectionResolution];


export function instanceOfCorrectionResolution(value: any): boolean {
    for (const key in CorrectionResolution) {
        if (Object.prototype.hasOwnProperty.call(CorrectionResolution, key)) {
            if (CorrectionResolution[key as keyof typeof CorrectionResolution] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CorrectionResolutionFromJSON(json: any): CorrectionResolution {
    return CorrectionResolutionFromJSONTyped(json, false);
}

export function CorrectionResolutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectionResolution {
    return json as CorrectionResolution;
}

export function CorrectionResolutionToJSON(value?: CorrectionResolution | null): any {
    return value as any;
}

export function CorrectionResolutionToJSONTyped(value: any, ignoreDiscriminator: boolean): CorrectionResolution {
    return value as CorrectionResolution;
}

